// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"1207b684","151":"19a85977","453":"34abe88b","691":"5ce81d0e","708":"4918bc0a"}[chunkId] + ".chunk.js";
};